/**
 * /dashboard/timesheet — Timesheet hub, "My week" view (SOP §1.2;
 * Phase 3b — 2026-06-01).
 *
 * The internal `[My week][Approvals]` Tabs pair from the legacy Next.js
 * hub was already removed in the same SOP pivot: Approvals queue now
 * lives at /dashboard/timesheet/inbox (deep link) and
 * /dashboard/approvals?tab=timesheet (canonical discovery from the Time
 * & Leave strip). This route is therefore JUST the caller's weekly grid.
 *
 * Module strip + PageHeader come from the shared TimeAndLeaveShell —
 * same DRY pattern as Calendar / Approvals / Leave.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/timesheet/page.tsx. The legacy
 * `?tab=approvals` redirect is dropped (every entry point now goes
 * through the typed router; no risk of a stale query-string deep link).
 */

import { createFileRoute } from "@tanstack/react-router";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { TimesheetFeatureGate } from "@/components/timesheet/timesheet-feature-gate";
import { MyTimesheetTab } from "@/components/timesheet/my-timesheet-tab";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/timesheet/")({
  component: TimesheetHubRoute,
});

function TimesheetHubRoute() {
  return (
    <TimeAndLeaveShell
      title="Timesheet"
      description="Log your hours and submit each week for approval."
    >
      <TimesheetFeatureGate>
        <MyTimesheetTab />
      </TimesheetFeatureGate>
    </TimeAndLeaveShell>
  );
}
